// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261304/js/" + chunkId + "." + {"44":"a89e18d5","225":"854171ae","481":"f20250e5","486":"23e74b35","770":"b077c248"}[chunkId] + ".0.16220451461746654.chunk.js";
};